module.exports = __webpack_public_path__ + "static/img/przybornik_wielkosc4.d2058119.png";